module.exports = __webpack_public_path__ + "img/sh_fb-y.7ffcbbe9.svg";